import { DocumentNode, TypedDocumentNode, useQuery } from '@apollo/client';

type UseEntitySearchProps<TData, TResult> = {
  query: DocumentNode | TypedDocumentNode<TData, any>;
  dataExtractor: (data: TData | undefined) => TResult[];
  searchText: string;
  limit?: number;
  skip?: boolean;
};

/**
 * Generic hook for searching entities in the global search
 */
export function useEntitySearch<TData, TResult>({
  query,
  dataExtractor,
  searchText,
  limit = 10,
  skip = false,
}: UseEntitySearchProps<TData, TResult>) {
  const { data, loading, error } = useQuery<TData>(query, {
    variables: {
      offset: 0,
      limit,
      text: `%${searchText.trim()}%`,
    },
    skip: skip || !searchText.trim(),
    fetchPolicy: 'cache-and-network',
  });

  const extractedData = !data ? [] : dataExtractor(data);

  return {
    data: extractedData,
    loading,
    error,
  };
}
